import { ChangeEvent, FC, ReactElement, useState } from 'react'
import { useNavigate, useParams } from 'react-router'

import { Button } from '@/components'
import { trans } from '@/helpers/trans'
import { registerShift } from '@/redux/shift/shiftActions'
import { useTypedDispatch } from '@/redux/store'

import './ShiftRegisterPage.scss'

export const ShiftRegisterPage: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const navigate = useNavigate()
    const { shiftUuid = '' } = useParams()
    const [comment, setComment] = useState('')

    const handleCommentChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
        setComment(event.target.value)
    }

    const handleSubmitClick = (): void => {
        dispatch(registerShift(shiftUuid, comment, navigate))
    }

    return (
        <>
            <div className="border-bottom">
                <div className="form-group pr-4 pl-4 pt-4">
                    <div className="font-weight-semi-bold mb-2">{trans('common.notes')}</div>
                    <textarea
                        className="form-control border-0"
                        value={comment}
                        onChange={handleCommentChange}
                        placeholder={trans('pages.shifts.addComment')}
                    />
                </div>
            </div>
            <Button
                text={trans('common.subscribe')}
                onClick={handleSubmitClick}
                className="shift-register__submit-button"
            />
        </>
    )
}
